import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

type RatingProps = {
  scoreVisibility?: 'row' | 'compact';
  size?: 'small' | 'normal';
  $newOfferItemExperiment: boolean;
};

export const IconWrapper = styled.div.attrs({
  'data-test': 'Rating',
})<RatingProps>(
  props => css`
    display: flex;
    align-items: center;

    ${props.scoreVisibility === 'compact' &&
      css`
        &::after {
          content: attr(data-rating);
          position: absolute;
          bottom: -8px;
          left: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 13px;
          border-radius: 8px;
          font-size: 10px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          background: ${props.theme.ratings.disabled.bg};
          color: ${props.theme.ratings.disabled.fg};
        }
      `}

    ${props.scoreVisibility === 'row' &&
      css`
        &::after {
          content: attr(data-rating);
          display: inline;
          line-height: 1.4;
          font-size: ${layout.measurements.fontSizeNormal};
          margin-left: ${layout.measurements.spacing025};
          color: ${p => p.theme.text.secondary};

          ${props.$newOfferItemExperiment &&
            media.smallOnly`
            color: ${p => p.theme.text.primary};
            `}

          ${props.size === 'small' &&
            css`
              font-size: ${layout.measurements.fontSizeSmall};
            `}
        }
      `}
  `
);

export const RatingSmiley = styled.div`
  position: relative;
  display: flex;
`;

export const RatingCount = styled.p(
  props => css`
    margin: 0 0 0 ${layout.measurements.spacing025};
    font-size: ${layout.measurements.fontSizeSmall};
    color: ${props.theme.text.quaternary};
  `
);
